<template>
  <div class="relative overflow-hidden">
    <!-- Hero Section -->
    <div class="relative pt-32 pb-20 sm:pt-40 sm:pb-28 lg:pt-48">
      <div class="absolute inset-0 -z-10">
        <div class="absolute inset-0 bg-gradient-to-b from-primary-600 to-primary-800 opacity-90"></div>
        <div class="absolute inset-0 opacity-30 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ3aGl0ZSI+PC9yZWN0PgogIDxwYXRoIGQ9Ik0wIDBMNTAgNTBMOTkgMEg3NUw1MCAyNUwyNSAwSDBaIiBmaWxsPSIjMDA3NGQ1IiBvcGFjaXR5PSIwLjA1Ij48L3BhdGg+Cjwvc3ZnPg==')]"></div>
      </div>
      
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="max-w-3xl mx-auto text-center">
          <h1 class="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
            数据驱动创新 智能赋能产业
          </h1>
          <p class="mt-6 text-xl text-primary-100 max-w-2xl mx-auto">
            上海维域信息科技专注于边缘计算与数据智能领域,为多行业客户提供高价值的数字化、智能化服务
          </p>
          <div class="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <router-link 
              to="/solutions" 
              class="btn bg-white text-primary-700 hover:bg-gray-100 px-8 py-4 text-base font-medium"
            >
              了解解决方案
            </router-link>
            <router-link 
              to="/contact" 
              class="btn bg-transparent border-2 border-white text-white hover:bg-white hover:bg-opacity-10 px-8 py-4 text-base font-medium"
            >
              联系我们
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Features Section -->
    <div class="py-16 bg-white sm:py-24">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center">
          <h2 class="section-title">
            核心业务
          </h2>
          <p class="mt-4 max-w-2xl text-xl text-gray-600 mx-auto">
            我们专注于边缘计算与数据智能领域，提供技术解决方案
          </p>
        </div>

        <div class="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-2">
          <!-- Feature 1 -->
          <div class="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow">
            <div class="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
              <svg class="w-8 h-8 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5.25 16.5h9.5l-3.841-6.091a2.25 2.25 0 01-.659-1.591V3.104z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 3.104c0-.966.784-1.75 1.75-1.75h14.5c.966 0 1.75.784 1.75 1.75v11.5a1.75 1.75 0 01-1.75 1.75h-4.5v2.5a.75.75 0 11-1.5 0v-2.5H4.75A1.75 1.75 0 013 14.604V3.104z" />
              </svg>
            </div>
            <h3 class="text-xl font-bold text-gray-900 mb-3">低空经济边缘算力端解决方案</h3>
            <p class="text-gray-600">
              为低空飞行器提供实时数据处理能力，支持物流配送、城市巡检、应急救援等场景，将数据处理延迟压缩至毫秒级。
            </p>
            <div class="mt-4">
              <router-link to="/solutions/low-altitude" class="text-primary-600 hover:text-primary-700 font-medium">
                了解更多 →
              </router-link>
            </div>
          </div>

          <!-- Feature 2 -->
          <div class="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow">
            <div class="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
              <svg class="w-8 h-8 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5.25 16.5h9.5l-3.841-6.091a2.25 2.25 0 01-.659-1.591V3.104z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 3.104c0-.966.784-1.75 1.75-1.75h14.5c.966 0 1.75.784 1.75 1.75v11.5a1.75 1.75 0 01-1.75 1.75h-4.5v2.5a.75.75 0 11-1.5 0v-2.5H4.75A1.75 1.75 0 013 14.604V3.104z" />
              </svg>
            </div>
            <h3 class="text-xl font-bold text-gray-900 mb-3">具身智能边缘算力端解决方案</h3>
            <p class="text-gray-600">
              为机器人和智能终端提供本地化智能感知与控制能力，实现高效的环境感知、任务规划与动作执行，降低对云端算力的依赖。
            </p>
            <div class="mt-4">
              <router-link to="/solutions/embodied-ai" class="text-primary-600 hover:text-primary-700 font-medium">
                了解更多 →
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div class="bg-primary-700">
      <div class="container mx-auto px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div class="bg-primary-600 rounded-2xl px-6 py-16 sm:p-16">
          <div class="max-w-3xl mx-auto text-center">
            <h2 class="text-3xl font-extrabold text-white sm:text-4xl">
              加入我们，共创智能未来
            </h2>
            <p class="mt-4 text-lg text-primary-100">
              我们正在寻找有才华的工程师和行业专家加入我们的团队，共同推动边缘计算与数据智能的发展。
            </p>
            <div class="mt-8">
              <router-link 
                to="/careers" 
                class="btn bg-white text-primary-700 hover:bg-gray-100 px-8 py-3 text-base font-medium"
              >
                查看职位
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Component logic here
</script>
